import React from 'react';
import formatCurrencyToLocal from '../../../../helpers/utils/formatCurrencyToLocal';
import { termsDataMonths } from "../../enums/termsData";

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
      cardType = calc.props.cardType,
      realRates = {
        atb: 'від 49.34% до 62.39%',
        premium: 'від 42.63% до 336.23%'
      };

    return (
        <React.Fragment>
          <div className="loan-conditions-table">
            <div className="loan-conditions-item">
              <div className="condition-title">{calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW')}</div>
              <div className="condition-text">{model.getNewRequiredPayment(model.getCreditSum()).toLocaleString()} {calc.l10n('UAH_ICON')}</div>
            </div>
            <div className="loan-conditions-item">
              <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN')}</div>
              <div className="condition-text">{model.getCreditSum().toLocaleString()} {calc.l10n('UAH_ICON')}</div>
            </div>
          </div>
          <div className="loan-conditions-lines">
            <div className="loan-conditions-item">
              <div className="condition-title">{calc.l10n('CALCULATOR_OVERPAYMENT')}</div>
              <div className="condition-text">{formatCurrencyToLocal(model.getNewOverpayment(model.getCreditSum()))} {calc.l10n('UAH_ICON')}</div>
            </div>
            <div className="loan-conditions-item">
              <div className="condition-title">{calc.l10n('CALCULATOR_CREDIT_CARDS_REAL_YEAR_RATE')}</div>
              <div className="condition-text">{model.getNewRealRate(model.getCreditSum())}{calc.l10n('CALCULATOR_CREDIT_PERCENT')}</div>
            </div>
            <div className="loan-conditions-item">
              <div className="condition-title">{calc.l10n('CALCULATOR_TOTAL_COST')}</div>
              <div className="condition-text">{formatCurrencyToLocal(model.getNewCreditCost(model.getCreditSum()))} {calc.l10n('UAH_ICON')}</div>
            </div>
          </div>
        </React.Fragment>
    );
}
